// extracted by mini-css-extract-plugin
module.exports = {"layout":"MiddleLayout_layout__2AVo9","stretch":"MiddleLayout_stretch__2gu1u","centerContent":"MiddleLayout_centerContent__5M4qo"};